import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { FaLaptopCode } from 'react-icons/fa';

const OpenSource: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-stone-50'}`}>
      <main className="pt-20 pb-20">
        <div className="max-w-[1400px] mx-auto px-12">
          {/* Header */}
          <div className="mb-16">
            <h1 className={`text-6xl mb-6 ${isDarkMode ? 'text-white' : 'text-stone-900'}`} style={{ fontFamily: 'Georgia, serif' }}>
              Open Source Projects
            </h1>
            <p className={`text-xl ${isDarkMode ? 'text-gray-300' : 'text-stone-600'}`} style={{ fontFamily: 'Georgia, serif' }}>
              Contributing to bioinformatics tools and sharing knowledge with the community.
            </p>
          </div>

          {/* Coming Soon Section */}
          <div className={`text-center py-20 px-8 ${isDarkMode ? 'bg-gray-800' : 'bg-stone-100'} rounded-3xl`}>
            <FaLaptopCode className={`w-20 h-20 ${isDarkMode ? 'text-gray-400' : 'text-stone-700'} mx-auto mb-6`} />
            <h2 className={`text-4xl mb-6 ${isDarkMode ? 'text-white' : 'text-stone-900'}`} style={{ fontFamily: 'Georgia, serif' }}>
              Coming Soon
            </h2>
            <p className={`text-xl ${isDarkMode ? 'text-gray-300' : 'text-stone-600'} max-w-2xl mx-auto`} style={{ fontFamily: 'Georgia, serif' }}>
              Open source contributions and projects will be showcased here soon. Check back to see bioinformatics tools, data science libraries, and collaborative work.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OpenSource;
